import type { AssignedMembership } from '../@types/AssignedMembership';
import type { Actions } from '../actions';
import {
  RCV_ASSIGNED_MEMBERSHIP_GET,
  RCV_ASSIGNED_MEMBERSHIP_REMOVE,
  RCV_ASSIGNED_MEMBERSHIP_SET,
  REQ_ASSIGNED_MEMBERSHIP_GET,
  REQ_ASSIGNED_MEMBERSHIP_REMOVE,
  REQ_ASSIGNED_MEMBERSHIP_SET,
  REQUEST_FAILED,
} from '../actions/assigned-membership';
import { requestStatus, responseStatus } from '../shared/statuses';

/* ----------------- INITIAL STATE ----------------- */

interface AssignedMembershipState {
  requestStatus: number;
  responseStatus: number;
  previousRequest: number | null;
  assignedMembership: AssignedMembership | null;
  lastLookupEntityId: string | null;
}

const _initialState: AssignedMembershipState = {
  requestStatus: requestStatus.WAITING,
  responseStatus: responseStatus.OK,
  previousRequest: null,
  assignedMembership: null,
  lastLookupEntityId: null,
};

/* ----------------- STATUS HELPERS ----------------- */

const getSuccessfulResponse = (newState: AssignedMembershipState) => {
  return {
    ...newState,
    requestStatus: requestStatus.WAITING,
    responseStatus: responseStatus.OK,
  };
};

const getPendingRequest = (state: AssignedMembershipState, status: number) => {
  return {
    ...state,
    requestStatus: status,
    responseStatus: responseStatus.PENDING,
  };
};

/* ----------------- REDUCER ----------------- */

const assignedMembershipReducer = (
  state: AssignedMembershipState = _initialState,
  action: Actions,
): AssignedMembershipState => {
  switch (action.type) {
    case REQ_ASSIGNED_MEMBERSHIP_GET:
      return getPendingRequest(
        { ...state, lastLookupEntityId: action.entityId, assignedMembership: null },
        requestStatus.FETCHING,
      );

    case REQ_ASSIGNED_MEMBERSHIP_SET:
      return getPendingRequest(state, requestStatus.CREATING);

    case REQ_ASSIGNED_MEMBERSHIP_REMOVE:
      return getPendingRequest(state, requestStatus.REMOVING);

    case RCV_ASSIGNED_MEMBERSHIP_GET:
      return getSuccessfulResponse({ ...state, assignedMembership: action.response });

    case RCV_ASSIGNED_MEMBERSHIP_SET:
      return getSuccessfulResponse({ ...state, assignedMembership: action.response });

    case RCV_ASSIGNED_MEMBERSHIP_REMOVE:
      return getSuccessfulResponse({ ...state, assignedMembership: null });

    case REQUEST_FAILED:
      return {
        ...state,
        requestStatus: requestStatus.WAITING,
        responseStatus: responseStatus.FAILED,
        previousRequest: state.requestStatus,
      };

    default:
      return state;
  }
};

export default assignedMembershipReducer;
